import Vue from "vue";
export default Vue.extend({
    name: "CardBody",
    props: {
        tight: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        bodyClasses() {
            return this.tight ? "c-card__body--tight" : "c-card__body";
        }
    }
});
